import React from 'react';
import PropTypes from 'prop-types';
import { Section } from 'components/core/Page';
import './CityCardList.scss';
import CityCard from '../../molecules/CityCard/CityCard';

const DEFAULT_DRILLDOWN_LINKS = [];

const CityCardList = ({ drilldownLinks = DEFAULT_DRILLDOWN_LINKS }) => {
	if (!drilldownLinks || drilldownLinks.length === 0) return null;
	return (
		<Section className="city-card-list">
			{drilldownLinks.map((cityData) => (
				<div key={cityData.city + '-' + cityData.state}>
					<CityCard cityData={cityData} />
				</div>
			))}
		</Section>
	);
};

CityCardList.propTypes = {
	drilldownLinks: PropTypes.arrayOf(PropTypes.object),
};

export default CityCardList;
